export type ContactRequestPriceLabels = {
    taxed: { netPrice: string; vatRate: string; grossPrice: string };
    untaxed: { price: string };
};

export function formatChfAmount(amount: number): string {
    return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(amount);
}

export function appendPriceBreakdownToContactMessage(
    message: string,
    prices: { netPriceChf: number; vatRatePercent: number; grossPriceChf: number },
    labels: ContactRequestPriceLabels,
): string {
    const lines =
        prices.vatRatePercent > 0
            ? [
                  `${labels.taxed.netPrice}: ${formatChfAmount(prices.netPriceChf)}`,
                  `${labels.taxed.vatRate}: ${prices.vatRatePercent}%`,
                  `${labels.taxed.grossPrice}: ${formatChfAmount(prices.grossPriceChf)}`,
              ]
            : [`${labels.untaxed.price}: ${formatChfAmount(prices.grossPriceChf)}`];
    const breakdown = lines.join('\n');
    const trimmed = message.trim();
    return trimmed ? `${trimmed}\n\n${breakdown}` : breakdown;
}
